import { createStyles } from 'antd-style'

export default createStyles(({ token }) => {
  return {
    operandConstructorContainer: {
      padding: token.padding,
    },
  }
})
